var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.636364 4.45454H11.8273L9.73182 6.55004C9.4833 6.79852 9.4833 7.20146 9.73182 7.44998C9.85609 7.5742 10.019 7.63635 10.1818 7.63635C10.3447 7.63635 10.5076 7.5742 10.6318 7.44994L13.8136 4.26812C14.0621 4.01964 14.0621 3.6167 13.8136 3.36818L10.6318 0.186359C10.3833 -0.0621197 9.98035 -0.0621197 9.73182 0.186359C9.4833 0.434838 9.4833 0.837784 9.73182 1.0863L11.8273 3.18181H0.636364C0.284921 3.18181 0 3.46673 0 3.81817C0 4.16961 0.284921 4.45454 0.636364 4.45454Z",
    fill: "#21AAE9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.cb43d81e2719ccf0ec96955b06a7bfb3.svg";
export { ForwardRef as ReactComponent };